import { useState } from "react";
import GenerateReport from "./GenerateReport";

// ═══════════════════════════════════════════════════════
// MATRICE DE SCORING — QUESTIONNAIRE A — 5-7 ANS
// 100% PARENT — ACTIVITÉS D'ÉVEIL
// ═══════════════════════════════════════════════════════


// À 5-7 ans : pas de spécialisation — activités d'ÉVEIL uniquement
const PROFILES = {
  INT: {
    name: "L'Énergique",
    emoji: "⚡",
    tagline: "Il déborde d'énergie — il a besoin de bouger constamment",
    description: "Votre enfant apprend et s'épanouit par le mouvement et la dépense physique. Son corps est en permanence en action. Les activités calmes le frustrent rapidement.",
    color: "#E8732A", bg: "#FFF0E6",
    top: [
      { emoji: "🤸", name: "Éveil sportif multi-activités", why: "Courir, sauter, grimper — activités variées adaptées à son énergie" },
      { emoji: "🏊", name: "Bébé nageur / natation éveil", why: "Dépense physique totale, découverte de l'eau, sécurité aquatique" },
      { emoji: "🥋", name: "Mini-judo ou mini-karaté", why: "Canaliser l'énergie, apprentissage du respect, effort contrôlé" },
      { emoji: "⚽", name: "Foot à 5 ou mini-foot", why: "Courir sans arrêt, jeu collectif simple, beaucoup de mouvement" },
    ],
    explore: ["Baby-gym", "Escalade enfants", "Athlétisme éveil", "Mini-tennis"],
    avoid: "Les activités trop statiques ou qui demandent de rester assis longtemps — solfège strict, activités manuelles très fines.",
    age_note: "À 5-7 ans, l'objectif est de découvrir et de s'amuser. Évitez la spécialisation — proposez plusieurs activités en parallèle.",
  },
  PRE: {
    name: "Le Minutieux",
    emoji: "🎯",
    tagline: "Il prend son temps et fait les choses bien — la précision le fascine",
    description: "Votre enfant est naturellement attiré par les activités qui demandent de la précision et de l'application. Il observe avant d'agir, prend soin de bien faire chaque geste.",
    color: "#3D2B8E", bg: "#EDE8FF",
    top: [
      { emoji: "🎨", name: "Arts plastiques enfants", why: "Précision des gestes, création visible, liberté dans le cadre" },
      { emoji: "🏹", name: "Tir à l'arc initiation", why: "Concentration, geste précis, résultat immédiat et visible" },
      { emoji: "🎭", name: "Danse classique initiation", why: "Précision du geste, progression visible, discipline bienveillante" },
      { emoji: "🎵", name: "Éveil musical avec instrument", why: "Précision rythmique, apprentissage progressif, concentration" },
    ],
    explore: ["Natation technique", "Poterie enfants", "Origami / papier créatif", "Mini-golf"],
    avoid: "Les activités trop chaotiques ou sans objectif précis — sports collectifs très libres, jeux de rôle sans structure.",
    age_note: "À cet âge, la précision se développe — ne forcez pas. Encouragez l'effort plutôt que le résultat parfait.",
  },
  EXP: {
    name: "L'Expressif",
    emoji: "🎨",
    tagline: "Son corps et ses mains sont ses outils d'expression naturels",
    description: "Votre enfant utilise son corps, ses mains et sa voix pour communiquer et créer. Il s'exprime naturellement par le mouvement, le dessin ou le chant. La liberté créative est essentielle pour lui.",
    color: "#9B4FBB", bg: "#F5E8FF",
    top: [
      { emoji: "💃", name: "Danse éveil — hip-hop ou contemporaine", why: "Expression corporelle libre, musique, mouvement créatif" },
      { emoji: "🎨", name: "Ateliers créatifs multi-supports", why: "Peinture, argile, collage — liberté totale d'expression" },
      { emoji: "🎭", name: "Théâtre enfants / contes animés", why: "Expression corporelle et verbale, imaginaire, jeu créatif" },
      { emoji: "🎵", name: "Éveil musical et chant", why: "Expression par la voix et le rythme, plaisir immédiat" },
    ],
    explore: ["Capoeira enfants", "Arts du cirque bébé", "Mime et expression corporelle", "Marionnettes"],
    avoid: "Les activités très codifiées sans espace créatif — gym suédoise stricte, activités très répétitives.",
    age_note: "L'expression libre est prioritaire à cet âge. Choisissez des cours où le plaisir prime sur la technique.",
  },
  COL: {
    name: "Le Sociable",
    emoji: "🤝",
    tagline: "Il s'épanouit avec les autres — la solitude le décourage",
    description: "Votre enfant a besoin des autres pour donner le meilleur de lui-même. Il cherche naturellement le contact, le jeu partagé, les activités en groupe. Seul, il s'ennuie rapidement.",
    color: "#1B6B3A", bg: "#E8F5E9",
    top: [
      { emoji: "⚽", name: "Sports collectifs éveil", why: "Jouer ensemble, partager, victoires et défaites collectives" },
      { emoji: "🎭", name: "Théâtre enfants en groupe", why: "Créer ensemble, liens forts, spectacle partagé" },
      { emoji: "🎵", name: "Chorale enfants", why: "Chanter ensemble, appartenance au groupe, harmonie collective" },
      { emoji: "🤸", name: "Gym collective ou sports co", why: "Activités en groupe, encouragements mutuels, ambiance festive" },
    ],
    explore: ["Basketball mini", "Handball mini", "Danse en groupe", "Activités nature en groupe"],
    avoid: "Les activités strictement individuelles où l'enfant est seul pendant tout le cours — tir à l'arc seul, natation sans groupe.",
    age_note: "Choisissez des clubs avec une bonne ambiance et un encadrant bienveillant — l'ambiance compte plus que l'activité à cet âge.",
  },
  SCE: {
    name: "Le Petit Performer",
    emoji: "🎭",
    tagline: "Il adore être regardé — le public le transforme",
    description: "Votre enfant est différent quand on le regarde. Les spectacles de fin d'année, les petites représentations devant la famille — il s'y prépare avec sérieux et y brille naturellement.",
    color: "#1565C0", bg: "#E3F2FD",
    top: [
      { emoji: "🎭", name: "Théâtre enfants", why: "Être sur scène, public, représentations, applaudi — son terrain naturel" },
      { emoji: "💃", name: "Danse avec spectacles", why: "Représentations régulières, costumes, public — il adore ça" },
      { emoji: "🎵", name: "Chant ou chorale avec concerts", why: "Se produire devant les autres, être regardé, être applaudi" },
      { emoji: "🎪", name: "Arts du cirque initiation", why: "Numéros devant les familles, acrobaties, show — idéal pour lui" },
    ],
    explore: ["Comédie musicale enfants", "Marionnettes avec représentations", "Magie initiation", "Gym rythmique avec gala"],
    avoid: "Les activités sans représentation publique — natation pure, sports individuels sans public.",
    age_note: "Cherchez des clubs qui organisent des spectacles ou galas réguliers — c'est ce qui maintiendra sa motivation.",
  },
  CRE: {
    name: "Le Créateur",
    emoji: "🔨",
    tagline: "Il fabrique, construit, invente — ses mains sont toujours en action",
    description: "Votre enfant passe des heures à construire, assembler, fabriquer. Il a une relation particulière aux objets et aux matières. Créer quelque chose de tangible avec ses mains est sa plus grande satisfaction.",
    color: "#C07020", bg: "#FFF3E0",
    top: [
      { emoji: "🎨", name: "Ateliers poterie / argile", why: "Créer avec ses mains, objet tangible, liberté de forme" },
      { emoji: "🔨", name: "Ateliers bois / bricolage enfants", why: "Construire, assembler, résultat visible et solide" },
      { emoji: "🤖", name: "Robotique / Lego Technic éveil", why: "Construire des mécanismes, voir son travail fonctionner" },
      { emoji: "🎨", name: "Arts plastiques multi-matières", why: "Peindre, coller, sculpter — créer avec tous les matériaux" },
    ],
    explore: ["Couture enfants", "Menuiserie junior", "Jardinage enfants", "Cuisine créative"],
    avoid: "Les activités où on ne produit rien de tangible — courses, natation pure, sports sans création.",
    age_note: "Cherchez des ateliers où l'enfant repart avec quelque chose qu'il a fait — c'est ce qui l'accroche.",
  },
};


const QUESTIONS = [
  {
    id: "Q1", text: "Quand votre enfant joue librement, que fait-il spontanément ?",
    consigne: "Cochez les 2 comportements les plus fréquents", multi: true, max: 2,
    options: [
      { id: "A", text: "Il court, saute, grimpe — son corps est en permanence en action", scores: { INT: 3 } },
      { id: "B", text: "Il s'installe et construit, empile, assemble — Lego, kapla, pâte à modeler", scores: { CRE: 3 } },
      { id: "C", text: "Il danse, tourne, fait des figures — le mouvement en musique l'attire", scores: { EXP: 3 } },
      { id: "D", text: "Il écoute ou joue de la musique, chante, frappe le rythme", scores: { EXP: 2, SCE: 1 } },
      { id: "E", text: "Il dessine, colorie, crée des personnages ou des histoires", scores: { CRE: 2, EXP: 1 } },
      { id: "F", text: "Il joue avec d'autres enfants — il a besoin du groupe pour s'épanouir", scores: { COL: 3 } },
    ],
  },
  {
    id: "Q2", text: "Comment votre enfant bouge-t-il naturellement ?",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Avec beaucoup d'énergie et d'intensité — il ne fait jamais les choses à moitié", scores: { INT: 3 } },
      { id: "B", text: "Avec précision et soin — il prend le temps de bien faire chaque geste", scores: { PRE: 3 } },
      { id: "C", text: "Avec fluidité et grâce — ses mouvements semblent naturellement expressifs", scores: { EXP: 3 } },
      { id: "D", text: "Avec prudence — il observe avant de se lancer, évite les risques physiques", scores: { PRE: 2 } },
    ],
  },
  {
    id: "Q3", text: "Face à un défi physique (obstacle à franchir, escalier à grimper...), il...",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Se lance immédiatement sans réfléchir — il adore les défis physiques", scores: { INT: 2 } },
      { id: "B", text: "Observe d'abord, évalue, puis tente — il prend le temps de préparer", scores: { PRE: 2 } },
      { id: "C", text: "Demande de l'aide ou cherche un accompagnateur — le groupe le rassure", textF: "Demande de l'aide ou cherche un accompagnateur — le groupe la rassure", scores: { COL: 2 } },
      { id: "D", text: "Préfère contourner ou trouver une autre solution créative", scores: { CRE: 2 } },
    ],
  },
  {
    id: "Q4", text: "Avec d'autres enfants, votre enfant a naturellement tendance à...",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Prendre l'initiative et proposer les règles du jeu — il organise spontanément", scores: { COL: 1, SCE: 1 } },
      { id: "B", text: "Suivre et participer avec enthousiasme — il s'intègre facilement", scores: { COL: 2 } },
      { id: "C", text: "Jouer en parallèle près des autres sans vraiment interagir — dans sa bulle", scores: { CRE: 2, PRE: 1 } },
      { id: "D", text: "Chercher à aider ou inclure les enfants plus timides", scores: { COL: 2 } },
    ],
  },
  {
    id: "Q5", text: "Qu'est-ce qui calme votre enfant quand il est agité ou stressé ?",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Une activité physique intense — courir, sauter, se dépenser l'apaise", scores: { INT: 2 } },
      { id: "B", text: "La musique — écouter ou jouer le détend immédiatement", scores: { EXP: 2 } },
      { id: "C", text: "Créer quelque chose — dessiner, construire, modeler", scores: { CRE: 2 } },
      { id: "D", text: "Le contact physique et la présence d'un adulte — être tenu, câliné", scores: { COL: 1 } },
      { id: "E", text: "Un espace calme et du temps seul — il se régule mieux dans la solitude", scores: { PRE: 1 } },
    ],
  },
  {
    id: "Q6", text: "Quand il entend de la musique, votre enfant...",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Se met spontanément à bouger, danser, taper le rythme", scores: { EXP: 2, INT: 1 } },
      { id: "B", text: "S'arrête et écoute attentivement — la musique capte vraiment son attention", scores: { PRE: 1, EXP: 1 } },
      { id: "C", text: "Essaie de chanter ou de reproduire la mélodie", scores: { SCE: 2, EXP: 1 } },
      { id: "D", text: "Continue ce qu'il faisait sans vraiment réagir", scores: { CRE: 1 } },
    ],
  },
  {
    id: "Q7", text: "Face à quelque chose de nouveau (activité, jeu, lieu), votre enfant...",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Fonce directement — la curiosité et l'enthousiasme priment sur la prudence", scores: { INT: 2 } },
      { id: "B", text: "Observe longuement avant de participer", scores: { PRE: 2 } },
      { id: "C", text: "Cherche un enfant ou un adulte familier pour l'accompagner", scores: { COL: 2 } },
      { id: "D", text: "Pose beaucoup de questions avant de se lancer", scores: { PRE: 1, CRE: 1 } },
    ],
  },
  {
    id: "Q8", text: "Quelle activité absorbe votre enfant le plus longtemps sans qu'il s'ennuie ?",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Les jeux de construction — Lego, kapla, puzzles, maquettes", scores: { CRE: 3 } },
      { id: "B", text: "Le dessin, la peinture, les activités manuelles créatives", scores: { CRE: 2, EXP: 1 } },
      { id: "C", text: "La danse, le mime, les jeux de rôle expressifs", scores: { EXP: 3, SCE: 1 } },
      { id: "D", text: "Les jeux sportifs, la course, les jeux de poursuite", scores: { INT: 3 } },
      { id: "E", text: "Écouter des histoires, des chansons, regarder des spectacles", scores: { SCE: 2 } },
    ],
  },
  {
    id: "Q9", text: "Quand une activité est trop difficile, votre enfant...",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Insiste encore et encore — il ne lâche pas facilement", scores: { INT: 1, PRE: 1 } },
      { id: "B", text: "Se décourage et abandonne rapidement", scores: {} },
      { id: "C", text: "Cherche une stratégie différente — il contourne le problème", scores: { CRE: 2 } },
      { id: "D", text: "Demande de l'aide immédiatement", scores: { COL: 1 } },
      { id: "E", text: "Pleure ou se fâche, puis reprend rapidement", scores: { INT: 1 } },
    ],
  },
  {
    id: "Q10", text: "Quel type de jouet ou d'activité l'attire le plus spontanément ?",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Ballons, vélo, trottinette — tout ce qui permet de bouger", scores: { INT: 2 } },
      { id: "B", text: "Lego, puzzles, jeux de construction", scores: { CRE: 3 } },
      { id: "C", text: "Instruments de musique jouets, karaoké", scores: { EXP: 2, SCE: 1 } },
      { id: "D", text: "Déguisements, marionnettes, jeux de rôle", scores: { SCE: 2, EXP: 1 } },
      { id: "E", text: "Crayons, peinture, pâte à modeler", scores: { CRE: 2, EXP: 1 } },
    ],
  },
  {
    id: "Q11", text: "Votre enfant est le plus fier quand...",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "Il réussit un exploit physique — grimper plus haut, courir plus vite", scores: { INT: 2 } },
      { id: "B", text: "Il crée quelque chose qu'il peut montrer — dessin, construction, bricolage", scores: { CRE: 2 } },
      { id: "C", text: "Il fait rire ou réagir les autres — l'attention du groupe le stimule", textF: "Elle fait rire ou réagir les autres — l'attention du groupe la stimule", scores: { SCE: 2 } },
      { id: "D", text: "Il aide quelqu'un ou résout un conflit entre camarades", scores: { COL: 2 } },
      { id: "E", text: "Il maîtrise un mouvement ou une technique précise", scores: { PRE: 2 } },
    ],
  },
  {
    id: "Q12", text: "Sa relation aux règles et aux consignes dans une activité...",
    consigne: "Une seule réponse", multi: false, max: 1,
    options: [
      { id: "A", text: "Il respecte les règles naturellement et les rappelle aux autres", scores: { PRE: 1, COL: 1 } },
      { id: "B", text: "Il les respecte mais préfère les activités avec peu de contraintes", scores: { EXP: 1 } },
      { id: "C", text: "Il les contourne régulièrement — il préfère inventer ses propres règles", scores: { CRE: 2 } },
      { id: "D", text: "Il a besoin que les règles aient du sens pour les respecter", scores: { PRE: 1 } },
    ],
  },
  {
    id: "Q13", text: "Dans quel environnement votre enfant s'épanouit-il le mieux ?",
    consigne: "Cochez les 2 réponses les plus proches", multi: true, max: 2,
    options: [
      { id: "A", text: "En plein air, dans la nature, avec de l'espace pour courir et explorer", scores: { INT: 2 } },
      { id: "B", text: "Dans un espace calme et organisé, avec du matériel créatif", scores: { CRE: 2, PRE: 1 } },
      { id: "C", text: "Au milieu d'un groupe d'enfants animé et joyeux", scores: { COL: 2 } },
      { id: "D", text: "Dans un cadre structuré avec un adulte qui guide", scores: { PRE: 2 } },
    ],
  },
  {
    id: "Q14", text: "Son rapport à la compétition, même informelle (qui court le plus vite...) ?",
    consigne: "Une seule réponse", multi: false, max: 1,
    options: [
      { id: "A", text: "Il adore la compétition — il se dépasse quand il y a un enjeu", scores: { INT: 2 } },
      { id: "B", text: "Il aime gagner mais supporte bien la défaite", scores: { INT: 1, COL: 1 } },
      { id: "C", text: "La compétition le stresse — il préfère les activités sans enjeu", scores: { EXP: 1 } },
      { id: "D", text: "Il est indifférent — gagner ou perdre ne l'affecte pas vraiment", textF: "Elle est indifférente — gagner ou perdre ne l'affecte pas vraiment", scores: { CRE: 1 } },
    ],
  },
  {
    id: "Q15", text: "Si vous deviez choisir la phrase qui décrit le mieux votre enfant...",
    consigne: "Cochez les 2 phrases les plus vraies", multi: true, max: 2,
    options: [
      { id: "A", text: "Il a une énergie qui déborde — il doit bouger", scores: { INT: 2 } },
      { id: "B", text: "Il est dans sa bulle créative — il peut construire pendant des heures", scores: { CRE: 2 } },
      { id: "C", text: "Il a besoin des autres — il s'épanouit en groupe", scores: { COL: 2 } },
      { id: "D", text: "Il aime être regardé et applaudi — la scène l'attire", scores: { SCE: 2 } },
      { id: "E", text: "Il est prudent et réfléchi — il observe avant de se lancer", scores: { PRE: 2 } },
      { id: "F", text: "Il exprime tout par son corps — il danse, mime, s'exprime constamment", scores: { EXP: 2 } },
    ],
  },
];

function computeScores(answers) {
  const sc = { INT: 0, PRE: 0, EXP: 0, COL: 0, SCE: 0, CRE: 0 };
  QUESTIONS.forEach(q => {
    const ans = answers[q.id] || [];
    ans.forEach(sel => {
      const o = q.options.find(x => x.id === sel);
      if (o) Object.entries(o.scores).forEach(([k, v]) => { sc[k] += v; });
    });
  });
  const total = Object.values(sc).reduce((a, b) => a + b, 0) || 1;
  const pct = {};
  Object.keys(sc).forEach(k => { pct[k] = Math.round((sc[k] / total) * 100); });
  const sorted = Object.entries(sc).sort((a, b) => b[1] - a[1]);
  return { sc, pct, primary: sorted[0][0], secondary: sorted[1][0] };
}


function applyGenderOpt(text, gender) {
  if (!gender || gender === "Garçon") return text;
  return text
    .replace(/^Il /, "Elle ")
    .replace(/ — il /, " — elle ")
    .replace(/il a /g, "elle a ")
    .replace(/il adore/g, "elle adore")
    .replace(/il s.épanouit/g, "elle s'épanouit")
    .replace(/il ne fait/g, "elle ne fait")
    .replace(/il observe/g, "elle observe")
    .replace(/il cherche/g, "elle cherche")
    .replace(/il s.ennuie/g, "elle s'ennuie")
    .replace(/lui-même/g, "elle-même").replace(/le détend/g, "la détend").replace(/tenu, câliné/g, "tenue, câlinée").replace(/ce qu'il faisait/g, "ce qu'elle faisait").replace(/qu'il peut montrer/g, "qu'elle peut montrer").replace(/le stresse/g, "la stresse").replace(/Elle est indifférente/g, "Elle est indifférente").replace(/regardé et applaudi/g, "regardée et applaudie").replace(/prudent et réfléchi/g, "prudente et réfléchie");
}


function applyGenderQ(text, gender) {
  if (!gender) return text;
  const isF = gender === "Fille";
  const map = {
    "Quand votre enfant joue librement, que fait-il spontanément ?": { G: "Quand votre fils joue librement, que fait-il spontanément ?", F: "Quand votre fille joue librement, que fait-elle spontanément ?" },
    "Comment votre enfant bouge-t-il naturellement ?": { G: "Comment votre fils bouge-t-il naturellement ?", F: "Comment votre fille bouge-t-elle naturellement ?" },
    "Face à un défi physique (obstacle à franchir, escalier à grimper...), il...": { G: "Face à un défi physique (obstacle à franchir, escalier à grimper...), il...", F: "Face à un défi physique (obstacle à franchir, escalier à grimper...), elle..." },
    "Avec d'autres enfants, votre enfant a naturellement tendance à...": { G: "Avec d'autres enfants, votre fils a naturellement tendance à...", F: "Avec d'autres enfants, votre fille a naturellement tendance à..." },
    "Qu'est-ce qui calme votre enfant quand il est agité ou stressé ?": { G: "Qu'est-ce qui calme votre fils quand il est agité ou stressé ?", F: "Qu'est-ce qui calme votre fille quand elle est agitée ou stressée ?" },
    "Quand il entend de la musique, votre enfant...": { G: "Quand il entend de la musique, votre fils...", F: "Quand elle entend de la musique, votre fille..." },
    "Face à quelque chose de nouveau (activité, jeu, lieu), votre enfant...": { G: "Face à quelque chose de nouveau (activité, jeu, lieu), votre fils...", F: "Face à quelque chose de nouveau (activité, jeu, lieu), votre fille..." },
    "Quelle activité absorbe votre enfant le plus longtemps sans qu'il s'ennuie ?": { G: "Quelle activité absorbe votre fils le plus longtemps sans qu'il s'ennuie ?", F: "Quelle activité absorbe votre fille le plus longtemps sans qu'elle s'ennuie ?" },
    "Quand une activité est trop difficile, votre enfant...": { G: "Quand une activité est trop difficile, votre fils...", F: "Quand une activité est trop difficile, votre fille..." },
    "Quel type de jouet ou d'activité l'attire le plus spontanément ?": { G: "Quel type de jouet ou d'activité l'attire le plus spontanément ?", F: "Quel type de jouet ou d'activité l'attire le plus spontanément ?" },
    "Votre enfant est le plus fier quand...": { G: "Votre fils est le plus fier quand...", F: "Votre fille est la plus fière quand..." },
    "Sa relation aux règles et aux consignes dans une activité...": { G: "Sa relation aux règles et aux consignes dans une activité...", F: "Sa relation aux règles et aux consignes dans une activité..." },
    "Dans quel environnement votre enfant s'épanouit-il le mieux ?": { G: "Dans quel environnement votre fils s'épanouit-il le mieux ?", F: "Dans quel environnement votre fille s'épanouit-elle le mieux ?" },
    "Son rapport à la compétition, même informelle (qui court le plus vite...) ?": { G: "Son rapport à la compétition, même informelle (qui court le plus vite...) ?", F: "Son rapport à la compétition, même informelle (qui court le plus vite...) ?" },
    "Si vous deviez choisir la phrase qui décrit le mieux votre enfant...": { G: "Si vous deviez choisir la phrase qui décrit le mieux votre fils...", F: "Si vous deviez choisir la phrase qui décrit le mieux votre fille..." },
  };
  if (map[text]) return isF ? map[text].F : map[text].G;
  return text;
}

export default function MatriceA({ onBack }) {
  const [step, setStep] = useState(0);
  const [qi, setQi] = useState(0);
  const [answers, setAnswers] = useState({});
  const [name, setName] = useState("");
  const [gender, setGender] = useState(""); // eslint-disable-line
  const [age, setAge] = useState("");
  const [res, setRes] = useState(null);

  function answer(qId, oId, multi, max) {
    setAnswers(p => {
      const cur = p[qId] || [];
      if (!multi || max === 1) return { ...p, [qId]: [oId] };
      if (cur.includes(oId)) return { ...p, [qId]: cur.filter(x => x !== oId) };
      if (cur.length >= max) return { ...p, [qId]: [...cur.slice(1), oId] };
      return { ...p, [qId]: [...cur, oId] };
    });
  }

  function next() {
    if (qi < QUESTIONS.length - 1) setQi(qi + 1);
    else { setRes(computeScores(answers)); setStep(2); }
  }
  function prev() { if (qi > 0) setQi(qi - 1); else setStep(0); }

  const V = "#6B4FBB", VP = "#EDE8FF", G = "#E8C87A";
  const btn = (c = V) => ({ background: c, color: "#fff", border: "none", borderRadius: 100, padding: "12px 28px", fontSize: 15, fontWeight: 700, cursor: "pointer" });
  const bto = { background: "transparent", color: V, border: `2px solid ${VP}`, borderRadius: 100, padding: "10px 24px", fontSize: 14, cursor: "pointer" };
  const card = { background: "#fff", borderRadius: 20, padding: "28px 24px", maxWidth: 600, margin: "0 auto", boxShadow: "0 4px 24px rgba(107,79,187,0.08)" };
  const sm = { fontFamily: "system-ui", fontSize: 11, fontWeight: 700, letterSpacing: 2, color: "#9B7FE8", textTransform: "uppercase" };

  // INTRO
  if (step === 0) return (
    <div style={{ background: "#F5F2FF", minHeight: "100vh", fontFamily: "system-ui" }}>
      <div style={{ background: "linear-gradient(135deg, #4A2B8E, #6B4FBB)", padding: "28px 20px 24px", borderRadius: "0 0 24px 24px" }}>
        <div style={{ ...sm, color: "rgba(255,255,255,0.6)", marginBottom: 6 }}>Questionnaire A · 5-7 ans</div>
        <div style={{ fontSize: 24, fontWeight: 800, color: "#fff", marginBottom: 4 }}>Quel est le profil de votre enfant ?</div>
        <div style={{ fontSize: 14, color: "rgba(255,255,255,0.7)" }}>Questionnaire 100% rempli par les parents</div>
      </div>
      <div style={{ padding: 16 }}>
        <div style={card}>
          <div style={{ ...sm, marginBottom: 16 }}>Avant de commencer</div>
          <div style={{ fontSize: 14, color: "#1A1035", lineHeight: 1.7, marginBottom: 16 }}>
            À 5-7 ans, votre enfant n'a pas encore la capacité de s'auto-analyser. <b>Vous répondez seul à 15 questions</b> basées uniquement sur ce que vous observez au quotidien.
          </div>
          <div style={{ background: "#FDF6E3", borderLeft: `4px solid ${G}`, padding: "12px 14px", borderRadius: "0 8px 8px 0", fontSize: 13, color: "#6B5000", marginBottom: 24 }}>
            Répondez en pensant à des comportements réels observés — pas à ce que vous souhaiteriez pour votre enfant.
          </div>
          <div style={{ background: VP, borderLeft: "4px solid #6B4FBB", padding: "12px 14px", borderRadius: "0 8px 8px 0", fontSize: 13, color: "#3D2B8E", marginBottom: 24 }}>
            À cet âge, l'objectif est de trouver des <b>activités d'éveil</b> — pas une spécialisation. Les recommandations seront donc larges et variées.
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 12, color: "#9B7FE8", marginBottom: 5 }}>Prénom de l'enfant</div>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="Prénom..." style={{ width: "100%", padding: "10px 14px", border: `1.5px solid ${VP}`, borderRadius: 10, fontSize: 15, boxSizing: "border-box", fontFamily: "system-ui" }} />
          </div>
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 12, color: "#9B7FE8", marginBottom: 5 }}>Âge</div>
            <input value={age} onChange={e => setAge(e.target.value)} placeholder="Ex: 6 ans" style={{ width: "50%", padding: "10px 14px", border: `1.5px solid ${VP}`, borderRadius: 10, fontSize: 15, fontFamily: "system-ui" }} />
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 12, color: "#8B7BB5", marginBottom: 8 }}>Votre enfant est...</div>
            <div style={{ display: "flex", gap: 12 }}>
              {["Fille", "Garçon"].map(g => (
                <div key={g} onClick={() => setGender(g)}
                  style={{ flex: 1, padding: "10px", borderRadius: 12, cursor: "pointer", textAlign: "center", border: gender === g ? "2px solid #6B4FBB" : "2px solid #EDE8FF", background: gender === g ? "#EDE8FF" : "white", fontWeight: gender === g ? 700 : 400, color: gender === g ? "#3D2B8E" : "#1A1035", fontSize: 14 }}>
                  {g}
                </div>
              ))}
            </div>
          </div>
          </div>
          <button style={btn()} onClick={() => setStep(1)}>Commencer →</button>
        </div>
      </div>
    </div>
  );

  // QUESTIONS
  if (step === 1) {
    const q = QUESTIONS[qi];
    const ans = answers[q.id] || [];
    const pct = Math.round(((qi + 1) / QUESTIONS.length) * 100);
    const ok = q.multi ? ans.length > 0 : ans.length === 1;
    return (
      <div style={{ background: "#F5F2FF", minHeight: "100vh", fontFamily: "system-ui" }}>
        <div style={{ background: "linear-gradient(135deg, #4A2B8E, #6B4FBB)", padding: "20px 20px 16px", borderRadius: "0 0 20px 20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
            <div style={{ ...sm, color: "rgba(255,255,255,0.6)" }}>Pour les parents · {q.consigne}</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>{qi + 1}/{QUESTIONS.length}</div>
          </div>
          <div style={{ height: 5, background: "rgba(255,255,255,0.2)", borderRadius: 4 }}>
            <div style={{ height: "100%", background: G, borderRadius: 4, width: pct + "%", transition: "width 0.3s" }} />
          </div>
        </div>
        <div style={{ padding: 16 }}>
          <div style={card}>
            <div style={{ fontSize: 17, fontWeight: 700, color: "#1A1035", marginBottom: 6, lineHeight: 1.4 }}>{applyGenderQ(q.text, gender)}</div>
            <div style={{ fontSize: 12, color: "#9B7FE8", marginBottom: 16, fontStyle: "italic" }}>{q.consigne}</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 24 }}>
              {q.options.map(o => {
                const sel = ans.includes(o.id);
                return (
                  <div key={o.id} onClick={() => answer(q.id, o.id, q.multi, q.max)}
                    style={{ display: "flex", alignItems: "center", gap: 12, padding: "13px 16px", borderRadius: 12, cursor: "pointer", border: sel ? `2px solid ${V}` : `2px solid ${VP}`, background: sel ? VP : "#fff", transition: "all 0.15s" }}>
                    <span style={{ width: 20, height: 20, borderRadius: q.multi ? 4 : 100, border: sel ? "none" : "2px solid #C8B6F5", background: sel ? V : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 12, color: "#fff" }}>{sel ? "✓" : ""}</span>
                    <span style={{ fontSize: 14, fontWeight: sel ? 700 : 400, color: sel ? "#3D2B8E" : "#1A1035" }}>{gender === "Fille" ? (o.textF || applyGenderOpt(o.text, gender)) : o.text}</span>
                  </div>
                );
              })}
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button style={bto} onClick={prev}>← Retour</button>
              <button style={{ ...btn(), opacity: !ok ? 0.4 : 1 }} onClick={next} disabled={!ok}>
                {qi < QUESTIONS.length - 1 ? "Suivant →" : "Voir le profil →"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // RÉSULTATS
  if (step === 2 && res) {
    const P = PROFILES[res.primary];
    const S = PROFILES[res.secondary];
    const TC = "#1B6B6B";
    return (
      <div style={{ fontFamily: "system-ui", background: "#F5FAFA", minHeight: "100vh" }}>
        <div style={{ background: `linear-gradient(135deg, ${P?.color || TC}, ${S?.color || TC})`, padding: "40px 20px 32px", borderRadius: "0 0 32px 32px", textAlign: "center" }}>
          <div style={{ fontSize: 56, marginBottom: 8 }}>{P?.emoji}</div>
          <div style={{ fontSize: 26, fontWeight: 800, color: "#fff", marginBottom: 4 }}>{P?.name}</div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.7)", marginBottom: 16 }}>Profil principal</div>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.15)", borderRadius: 100, padding: "6px 16px" }}>
            <span>{S?.emoji}</span>
            <span style={{ fontSize: 13, color: "#fff", fontWeight: 600 }}>{S?.name} · profil secondaire</span>
          </div>
        </div>
        <div style={{ padding: "32px 20px", maxWidth: 560, margin: "0 auto", textAlign: "center" }}>
          <div style={{ background: "#fff", borderRadius: 20, padding: "28px 24px", marginBottom: 20, boxShadow: "0 4px 24px rgba(27,107,107,0.08)" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📄</div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: "#0D2B2B", margin: "0 0 12px" }}>
              Votre rapport personnalisé est prêt
            </h2>
            <p style={{ fontSize: 14, color: "#4A3F72", lineHeight: 1.7, margin: "0 0 24px" }}>
              Le rapport PDF contient le profil complet, les 4 dimensions, les activités recommandées et les conseils aux parents.
            </p>
            <GenerateReport childName={name} childAge={age} gender={gender} primaryKey={res.primary} secondaryKey={res.secondary} scores={res.pct} questionnaire="A" />
          </div>
          <button style={{ background: "transparent", color: TC, border: "2px solid #1B6B6B", borderRadius: 100, padding: "12px 28px", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "system-ui", marginTop: 8 }} onClick={onBack || (() => window.location.href = "/")}>
            Retour à l'accueil
          </button>
        </div>
      </div>
    );
  }

  return null;
}